<template>
  <div>
    <Modal
      v-model="visible"
      title="详情"
      width="1024"
      :closable="false"
      :mask-closable="false"
    >
      <div style="height: 400px">
        <div>
          <DatePicker
            v-model="searchDate"
            type="daterange"
            placement="bottom-end"
            placeholder="选择游戏时间"
            style="width: 200px"
          ></DatePicker>
          <Button type="primary" @click="queryGoods">查询</Button>

          <div style="overflow: auto; height: 330px">
            <Table
              :columns="columns1"
              :data="data1"
              :scroll="{ y: 100 }"
              height="330"
            >
            </Table>
          </div>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page
                :total="total"
                :page-size="50"
                :current="current"
                @on-change="changePage"
              ></Page>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="guanbimodal">取消</Button>
      </div>
    </Modal>

    <Modal
      v-model="kickModal"
      title="提示"
      :loading="kickSaving"
      @on-ok="kickUserConfirm"
      @on-cancel="kickModal = false"
    >
      <p>是否踢人?</p>
    </Modal>

    <Modal v-model="xiafenModal" title="查看下分" width="700" :footer-hide="true">
      <div v-if="xiafenImgUrl" style="text-align: center">
        <img :src="xiafenImgUrl" style="max-width: 100%" />
      </div>
      <div v-else>暂无图片</div>
    </Modal>
  </div>
</template>

<script>
import { cmsDevilcityGamelist,cmsKickUser } from "../../api/machine";
import { getUsername } from "../../utils/token";

export default {
  data() {
    return {
      searchDate: [],
      searchDate1: [],
      kickModal: false,
      kickSaving: false,
      kickRow: null,
      xiafenModal: false,
      xiafenImgUrl: "",
      data1: [], // 用于存储查询结果
      columns1Base: [
        {
          title: "上机时间",
          key: "uptime",
        },
        {
          title: "下机时间",
          key: "downtime",
        },
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "上机前金币",
          key: "upmoney",
        },
        {
          title: "花费金币",
          key: "coinnumber",
        },
        {
          title: "获得礼品",
          key: "wingiftname",
          render: (h, params) => {
            return h(
              "span",

              params.row.wingiftname + "*" + params.row.wingiftnum
            );
          },
        },
        {
          title: "获得金币",
          key: "wincoin",
        },
      ],

      current: 1,
      total: 0,
    };
  },
  computed: {
    columns1() {
      const yhmc = getUsername();
      const canShowAction = yhmc === "潮动经理" || yhmc === "潮动运营";
      const canShowXiafen = Number(this.videomachineid) == 1;
      if (!canShowAction && !canShowXiafen) return this.columns1Base;

      return [
        ...this.columns1Base,
        {
          title: "操作",
          render: (h, params) => {
            const buttons = [];

            if (canShowAction && params.row.gamestate == 0) {
              buttons.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.kickUser(params.row);
                      },
                    },
                  },
                  "踢人"
                )
              );
            }

            if (canShowXiafen) {
              buttons.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.openXiafenModal(params.row);
                      },
                    },
                  },
                  "查看下分"
                )
              );
            }

            return h("div", buttons);
          },
        },
      ];
    },
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    user_id: {
      type: String,
      required: true,
    },
    roomid: {
      type: String,
      required: true,
    },
    videomachineid: {
      type: [String, Number],
      required: false,
      default: 0,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        console.log("mgcGameListModal videomachineid:", this.videomachineid);
        // 当模态框打开时，清空备注内容
        this.searchDate = [];
        this.data1 = [];
        this.current = 1;
        this.total = 0;
        this.queryGoods();
      }
    },
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    kickUser(row) {
      this.kickRow = row;
      this.kickSaving = false;
      this.kickModal = true;
    },
    kickUserConfirm() {
      if (this.kickSaving) return;
      const id = this.kickRow && this.kickRow.id != null ? this.kickRow.id : undefined;
      if (id === undefined) {
        this.$Message.error("缺少id，无法踢人");
        return;
      }
      this.kickSaving = true;
      cmsKickUser({ id })
        .then(() => {
          this.$Message.success("踢人成功");
          this.kickModal = false;
          this.queryGoods();
        })
        .catch((error) => {
          console.error(error);
          this.$Message.error("踢人失败");
        })
        .finally(() => {
          this.kickSaving = false;
        });
    },
    openXiafenModal(row) {
      const id = row && row.id != null ? String(row.id) : "";
      if (!id) {
        this.$Message.error("缺少id");
        return;
      }
      this.xiafenImgUrl = "https://ossimg.zhizhuawulian.com/test/" + id + ".jpg";
      this.xiafenModal = true;
    },
    changeTab(index) {
      if (index == 0 && this.data1.length == 0) {
        this.queryGoods();
      }
    },
    guanbimodal() {
      this.$emit("guanbimodal");
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        machineNumber: this.user_id,
        roomid: this.roomid,
        starttime,
        endtime,
        page: this.current,
      };
      cmsDevilcityGamelist(params)
        .then((response) => {
          this.data1 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },
  },
};
</script>

<style scoped>
/* 添加一些样式，如果需要的话 */
</style>
